import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

type ManagedByExplanationContextType = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const ManagedByExplanationContext = createContext<ManagedByExplanationContextType>({
  isOpen: false,
  open: () => {
    throw new Error('ManagedByExplanationContext used before being provided');
  },
  close: () => {
    throw new Error('ManagedByExplanationContext used before being provided');
  },
});

type ManagedByExplanationProviderProps = { children: ReactNode };

export function ManagedByExplanationProvider({ children }: ManagedByExplanationProviderProps) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close]);

  return (
    <ManagedByExplanationContext.Provider value={value}>
      {children}
    </ManagedByExplanationContext.Provider>
  );
}

export function useManagedByExplanation() {
  return useContext(ManagedByExplanationContext);
}
